import Hero from "../../common/Hero";
import axios from "axios";
import { message, Spin, Modal } from "antd";
import BlogImage from "../../assests/images/blog.jpg";
import Footer from "../../common/Footer";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons";
import Navbar from "../../common/Navbar";

function Book() {
  const API_BASE = process.env.REACT_APP_API_BASE;

  const location = useLocation();
  const providerId = location.state?.providerId;
  const providerCategory = location.state?.providerCategory;
  const navigate = useNavigate();

  const userExist = localStorage.getItem("auth");
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isServiceChargeModalOpen, setIsServiceChargeModalOpen] = useState(true);
  const [providerInfo, setProviderInfo] = useState(null);

  const userData = userExist ? JSON.parse(userExist) : null;

  const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "FixItNow";
  const LOGO_URL = "https://yourdomain.com/logo.png";

  const [formData, setFormData] = useState({
    firstName: userData?.user?.firstName || "",
    lastName: userData?.user?.lastName || "",
    email: userData?.user?.email || "",
    phoneNumber: userData?.user?.phoneNumber || "",
    serviceName: providerCategory || "",
    serviceArea: "",
    address: "",
    mapAddress: "",
  });

  // ✅ Replace with your Formspree form URLs
  const customerForm = "https://formspree.io/f/movpqbka";
  const providerForm = "https://formspree.io/f/xgvpeqne";
  const adminForm = "https://formspree.io/f/xpwoznyw";

  useEffect(() => {
    if (!userExist) {
      navigate("/login");
    } else {
      setUser(true);
    }

    const fetchProviderDetails = async () => {
      try {
        const res = await axios.get(`${API_BASE}/user/providers/${providerId}`);
        setProviderInfo(res.data.provider);
      } catch (error) {
        console.error("Failed to fetch provider info:", error);
      }
    };

    if (providerId) fetchProviderDetails();
  }, [userExist, providerId, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleGetCurrentLocation = () => {
    if (!navigator.geolocation) {
      message.error("Geolocation not supported.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        const link = `https://www.google.com/maps?q=${latitude},${longitude}`;
        setFormData({ ...formData, mapAddress: link });
        message.success("Location added!");
      },
      () => message.error("Failed to fetch location.")
    );
  };

  // ✅ Email templates
  const customerTemplate = (data) => `
   <table width="100%" cellpadding="0" cellspacing="0" style="background-color:#f4f4f4; padding:20px;">
  <tr>
    <td align="center">
      <!-- Header -->
      <table width="600" cellpadding="0" cellspacing="0" style="background-color:white; border-radius:8px; overflow:hidden;">
        <tr>
          <td style="background-color:#d32f2f; text-align:center; padding:20px;">
            <img src="${LOGO_URL}" alt="${BRAND_NAME} Logo" width="80" style="margin-bottom:8px;">
            <h1 style="color:white; font-family:Arial,sans-serif; margin:0;">${BRAND_NAME}</h1>
          </td>
        </tr>

        <!-- Body -->
        <tr>
          <td style="padding:30px; font-family:Arial,sans-serif; color:#333;">
            <h2 style="color:#d32f2f;">Hi ${data.customer_name},</h2>
            <p>Thank you for booking <strong>${data.service_name}</strong> with ${BRAND_NAME}!</p>
            <p>Your booking details:</p>
            <ul style="color:#555; line-height:1.6;">
              <li><strong>Service Area:</strong> ${data.service_area}</li>
              <li><strong>Address:</strong> ${data.address}</li>
              <li><strong>Phone:</strong> ${data.phone}</li>
              <li><strong>Provider:</strong> ${data.provider_name}</li>
            </ul>
            <p>You can view your location here: <a href="${data.map_link}" style="color:#d32f2f;">View on Map</a></p>
            <p>We’ll contact you soon to confirm your booking.</p>
            <p style="margin-top:30px;">Best Regards,<br><strong>${BRAND_NAME} Team</strong></p>
          </td>
        </tr>

        <!-- Footer -->
        <tr>
          <td style="background-color:#f9f9f9; text-align:center; padding:20px; font-size:13px; color:#777;">
            <p style="margin:0;">&copy; ${new Date().getFullYear()} ${BRAND_NAME}. All rights reserved.</p>
            <p style="margin:4px 0;">
              <a href="mailto:support@fixitnow.com" style="color:#d32f2f;">support@fixitnow.com</a> |
              <a href="https://fixitnow.com" style="color:#d32f2f;">Visit Website</a>
            </p>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
  `;

  const providerTemplate = (data) => `
    <div style="font-family: Arial, sans-serif; padding: 20px; color: #333;">
      <h2 style="color: #1976d2;">New Booking Alert 🚀</h2>
      <p>You have received a new booking from <strong>${data.customer_name}</strong>.</p>
      <h3>Booking Details:</h3>
      <ul>
        <li><strong>Customer:</strong> ${data.customer_name}</li>
        <li><strong>Email:</strong> ${data.customer_email}</li>
        <li><strong>Phone:</strong> ${data.phone}</li>
        <li><strong>Service:</strong> ${data.service_name}</li>
        <li><strong>Area:</strong> ${data.service_area}</li>
        <li><strong>Address:</strong> ${data.address}</li>
        <li><strong>Map:</strong> <a href="${data.map_link}" target="_blank">View Location</a></li>
      </ul>
      <p style="margin-top:20px;">Please contact the customer promptly to confirm details.</p>
      <p style="color:#777;">Best Regards,<br/><strong>Service Platform Team</strong></p>
    </div>
  `;

  const adminTemplate = (data) => `
    <div style="font-family: Arial, sans-serif; padding: 20px; color: #333;">
      <h2 style="color: #2e7d32;">New Booking Received 🧾</h2>
      <p>A new booking has been created by <strong>${data.customer_name}</strong>.</p>
      <h3>Booking Summary:</h3>
      <ul>
        <li><strong>Customer:</strong> ${data.customer_name} (${data.customer_email})</li>
        <li><strong>Phone:</strong> ${data.phone}</li>
        <li><strong>Service:</strong> ${data.service_name}</li>
        <li><strong>Provider:</strong> ${data.provider_name}</li>
        <li><strong>Area:</strong> ${data.service_area}</li>
        <li><strong>Address:</strong> ${data.address}</li>
        <li><strong>Map:</strong> <a href="${data.map_link}" target="_blank">View Location</a></li>
      </ul>
      <p style="color:#777;">This is an automated notification for record keeping.</p>
      <p><strong>Service Booking Admin Panel</strong></p>
    </div>
  `;

  // ✅ Send emails via Formspree
  const sendEmail = async (url, subject, html) => {
    try {
      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject,
          message: html,
        }),
      });
    } catch (err) {
      console.error("Email send failed:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem("auth"))?.accessToken;

      // ✅ Save booking to backend
      await axios.post(
        `${API_BASE}/user/order`,
        {
          ...formData,
          providerId,
          providerName: `${providerInfo?.firstName} ${providerInfo?.lastName}`,
          providerCategory: providerInfo?.category,
          providerPhone: providerInfo?.phoneNumber,
          providerAddress: providerInfo?.address,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = {
        customer_name: `${formData.firstName} ${formData.lastName}`,
        customer_email: formData.email,
        phone: formData.phoneNumber,
        service_name: providerInfo?.category,
        service_area: formData.serviceArea,
        address: formData.address,
        map_link: formData.mapAddress,
        provider_name: `${providerInfo?.firstName} ${providerInfo?.lastName}`,
        provider_email: providerInfo?.email || "provider@example.com",
      };

      // ✅ Send 3 different email templates
      await Promise.all([
        sendEmail(customerForm, "Your Booking Confirmation", customerTemplate(data)),
        sendEmail(providerForm, "New Customer Booking Received", providerTemplate(data)),
        sendEmail(adminForm, "New Booking Created", adminTemplate(data)),
      ]);

      message.success("Booking confirmed and emails sent!");
      navigate("/thanks");
    } catch (error) {
      console.error("Booking error:", error);
      message.error("Booking failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  return (
    <>
      <Navbar />
      <Hero text="Book" text1="Services Now" image={BlogImage} />

      <Modal
        title="Service Charges"
        open={isServiceChargeModalOpen}
        onOk={() => setIsServiceChargeModalOpen(false)}
        onCancel={() => setIsServiceChargeModalOpen(false)}
        footer={[
          <button
            key="ok"
            className="bg-[#FF0000] text-white py-1 px-4 rounded"
            onClick={() => setIsServiceChargeModalOpen(false)}
          >
            OK
          </button>,
        ]}
      >
        <p className="text-lg">
          A compulsory service charge of <strong>200-RS</strong> will be added to your booking.
        </p>
      </Modal>

      <div className="flex justify-center p-4 sm:p-8">
        <div id="Request-a-quote" className="w-full max-w-5xl">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6 border-4 border-red-400 rounded-lg shadow-lg bg-white"
          >
            <h2 className="text-xl font-bold lg:col-span-2">Booking Form</h2>

            {providerInfo && (
              <div className="bg-gray-100 p-4 rounded mb-4 text-sm lg:col-span-2">
                <p><strong>Name:</strong> {providerInfo.firstName} {providerInfo.lastName}</p>
                <p><strong>Category:</strong> {providerInfo.category}</p>
                <p><strong>Address:</strong> {providerInfo.address}</p>
              </div>
            )}

            <input readOnly name="firstName" value={formData.firstName} className="p-2 border rounded" />
            <input readOnly name="lastName" value={formData.lastName} className="p-2 border rounded" />
            <input readOnly name="email" value={formData.email} className="p-2 border rounded" />
            <input readOnly name="phoneNumber" value={formData.phoneNumber} className="p-2 border rounded" />

            {/* <input readOnly value={providerCategory} className="p-2 border rounded bg-gray-100" /> */}
            <div className="flex items-center gap-3">
              <input
                readOnly
                value={providerCategory}
                className="p-2 border rounded bg-gray-100 flex-grow"
                placeholder="Select category"
              />

              <button
                onClick={() => navigate("/FilteredBook")}
                className="bg-[#ED5521] text-white font-semibold px-4 py-2 rounded hover:bg-[#c94312] transition"
              >
                Select Category
              </button>
            </div>

            {/* <select name="serviceArea" required onChange={handleChange}
              value={formData.serviceArea} className="p-2 border rounded">
              <option disabled value="">Select Area</option>
              <option value="Satellite Town">Satellite Town</option>
              <option value="Model Town">Model Town</option>
              <option value="Citi Housing">Citi Housing</option>
              <option value="Garden Town">Garden Town</option>
            </select> */}
            <select
              name="serviceArea"
              required
              onChange={handleChange}
              value={formData.serviceArea}
              className="p-2 border rounded"
            >
              <option disabled value="">
                Select Area
              </option>

              {[
                { name: "Hayes", url: "/hayes" },
                { name: "Hounslow", url: "/hounslow" },
                { name: "Southall", url: "/southall" },
                { name: "Uxbridge", url: "/uxbridge" },
                { name: "Greenford", url: "/greenford" },
                { name: "Northolt", url: "/northolt" },
                { name: "Windsor", url: "/windsor" },
                { name: "Ruislip", url: "/ruislip" },
                { name: "Harrow", url: "/harrow" },
                { name: "Maidenhead", url: "/maidenhead" },
                { name: "High Wycombe", url: "/highwycombe" },
              ].map((area) => (
                <option key={area.url} value={area.name}>
                  {area.name}
                </option>
              ))}
            </select>


            <input name="address" placeholder="Address" onChange={handleChange}
              value={formData.address} className="p-2 border rounded lg:col-span-2" />

            <div className="lg:col-span-2 flex">
              <input name="mapAddress" placeholder="Map link" onChange={handleChange}
                value={formData.mapAddress} className="p-2 border rounded w-full" />
              <button type="button" onClick={handleGetCurrentLocation}
                className="bg-[#FF0000] text-white px-3 py-1 rounded ml-2">
                <FontAwesomeIcon icon={faLocationArrow} />
              </button>
            </div>

            <div className="lg:col-span-2">
              <button type="submit" disabled={loading}
                className="bg-[#FF0000] w-full text-white py-2 px-4 rounded">
                {loading ? <Spin /> : "Send"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Book;
